
import CSSRulePlugin from 'imports-loader?define=>false!gsap/src/minified/plugins/CSSRulePlugin.min.js';

export default class Scens {
    constructor(controller) {
        this.controller = controller;
    }

    animation() {

        const animations = document.querySelectorAll("[data-item='animation']");

        if (animations) {

            animations.forEach(e => {
                new ScrollMagic.Scene({
                    triggerElement: e,
                    duration: '100%',
                    offset: -300,
                    reverse: false,
                })
                .on('start', function () {
        
                    //setTimeout(() => {
                        e.classList.add("animation");
                    //},300);
        
                })
                .addTo(this.controller);
            });

        }
    }

    map(getMapboxLoad) {

        const maps = document.querySelectorAll("[data-item='map']");

        if (maps) {

        maps.forEach(link => {

        new ScrollMagic.Scene({
            triggerElement: '[data-item="map"]',
            duration: '100%',
            offset: -500,
            reverse: false
        })
            .on('start', function () {
                const id = link.getAttribute("id");
                const address = link.dataset.address;
                let lng = parseFloat(link.dataset.lng);
                let lat = parseFloat(link.dataset.lat);

                getMapboxLoad.then(res => {
                    mapboxgl.accessToken = 'pk.eyJ1Ijoic3R1ZGlva2FkciIsImEiOiJjank1aTd1cTcwNGRhM2RsZjhzdjkyZTM4In0.kM77q6fgLkETu4ZL0e99lw';
                    lng = lng;
                    lat = lat;
                    
                    var map = new mapboxgl.Map({
                        container: id,
                        center: [lng, lat],
                        zoom: 14,
                        dragPan: window.innerWidth > 992 ? true : false,
                        style: 'mapbox://styles/mapbox/dark-v9'
                    });
                    
                    var geojson = {
                        type: 'FeatureCollection',
                        features: [{
                            type: 'Feature',
                            geometry: {
                                type: 'Point',
                                coordinates: [lng, lat]
                            }
                        }]
                    };
                    
                    geojson.features.forEach(function(marker) {
                        var el = document.createElement('div');
                        el.className = 'marker';
                    
                        new mapboxgl.Marker(el)
                            .setLngLat(marker.geometry.coordinates)
                            .setPopup(new mapboxgl.Popup({offset: 25})
                            .setHTML(address))
                            .addTo(map);
                    });
                    
                    map.scrollZoom.disable();
                    }).catch(e => {
                        console.log(e);
                    });
            })
            .addTo(this.controller);
        
        });
        }
    
    }
    
    
}